
export default function getClient(state) {
  return state.client;
}
